var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, OnInit } from '@angular/core';
import { Agent } from '../../../classes/agent';
import { ListingCategory } from '../../../classes/enums';
import { PreferencesService } from '../../../services/preferences.service';
import { CredentialsService } from '../../../services/credentials.service';
import { HasSubscriptions } from '../../has-subscriptions';
var ToggleFavouriteAgentComponent = /** @class */ (function (_super) {
    __extends(ToggleFavouriteAgentComponent, _super);
    function ToggleFavouriteAgentComponent(preferenceService, credentialsService) {
        var _this = _super.call(this) || this;
        _this.preferenceService = preferenceService;
        _this.credentialsService = credentialsService;
        _this.ListingCategory = ListingCategory;
        // FIXME: fix this for accessibility
        _this.onFocus = new EventEmitter();
        _this.showPopup = false;
        _this.showConfirmation = false;
        _this.isLoggedIn = false;
        return _this;
    }
    ToggleFavouriteAgentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.credentialsService.isLoggedIn.subscribe(function (val) { return _this.isLoggedIn = val; }));
    };
    /**
     * We don't allow toggling favourites if they're anonymous
     * @param isFavourited - the new status
     * @param confirmFavourite - when they're overwriting an existing one, we need a confirmation that they want to update
     */
    ToggleFavouriteAgentComponent.prototype.toggleFavouriteAgent = function (isFavourited, confirmFavourite) {
        this.showPopup = true;
        if (!this.isLoggedIn)
            return;
        if (this.favouriteAgentId && this.favouriteAgentId !== this.agent.sourceSystemId && !confirmFavourite) {
            this.showConfirmation = true;
        }
        else {
            this.preferenceService.toggleFavouriteAgent(isFavourited ? this.agent.sourceSystemId : null, isFavourited ? this.agent.detailUrl : null);
        }
    };
    ToggleFavouriteAgentComponent.prototype.onClick = function ($event) {
        $event.preventDefault();
        this.showPopup = false;
    };
    return ToggleFavouriteAgentComponent;
}(HasSubscriptions));
export { ToggleFavouriteAgentComponent };
